import React from "react";
import "../styles/Myself.css"
import FadeInSection from "./FadeIn";

class Myself extends React.Component {
  constructor() {
    super();
    this.state = {
      expanded: true,
      activeKey: "1"
    };
    this.handleSelect = this.handleSelect.bind(this);
  }
  handleSelect(eventKey) {
    this.setState({
      activeKey: eventKey
    });
  }
  render() {
    const one = (
      <p key={"one"}>
        I am a <b>Full-stack web developer</b>. I graduated from 
        <a href="https://www.lighthouselabs.ca"> Lighthouse Labs</a>, where I developed a diverse set of skills that enable me to create dynamic and engaging web applications.
      </p>
    );
    const two = (
      <p key={"two"}>
        Aside from web development, I have been exploring game development since gaming is one of my hobbies.
      </p>
    );
    // const three = (
    //   <p>
    //     <b>Want to chat?</b> Shoot me a message at{" "}
    //     <a href="mailto:gazi.jarin@mail.utoronto.ca">
    //       gazi.jarin@mail.utoronto.ca
    //     </a>{" "}
    //     and let's talk.
    //   </p>
    // );
    // const desc_items = [one, two];

    const tech_stack = [
      "Javascript ES6+",
      "React.js",
      "HTML & CSS",
      "Node.js",
      "PostgreSQL",
      "Express"
    ];

    // const tech_items = tech_stack.map(stack => <li>{stack}</li>);

    return (
      <div id="about">
        <FadeInSection>
          <div className="section-header ">
            <span className="section-title">Me, Myself & I</span>
          </div>
          <div className="about-content">
            <div className="about-description">
              {[one]}
              {"My Stack:"}
              <ul className="tech-stack">
                {tech_stack.map(function (tech_item, i) {
                  return (
                    <FadeInSection delay={`${i + 1}00ms`} key={i}>
                      <li>{tech_item}</li>
                    </FadeInSection>
                  );
                })}
              </ul>
              {[two]}
            </div>
            <div className="about-image">
              <img src={"https://user-images.githubusercontent.com/93356900/232898113-440b2cc5-9422-409a-9cd4-9645c70b8353.jpg"} alt="profile-pic"/>
            </div>
          </div>
        </FadeInSection>
      </div>
    );
  }
}

export default Myself;